import axiosInstance from "../axios/axiosInstance"

export const getCompany = async () => {
    console.log("env", process.env);
    return (await axiosInstance.get("/companies/com_3895a5b91100f01190cb6045bdc7c168")).data;
}